import { Markup } from 'interweave';
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getPrivacyData } from '../../Redux/ActionCreater';


function Privacy() {
    const [privacy,setPrivacy]=useState();
    const [loading,setLoading]=useState(true);
    
    const dispatch = useDispatch();
  const state = useSelector(
    (state) => (
       state.dataReducer
    ),
    shallowEqual
  );
    useEffect(() => {
        fetchData()
      }, [])
    
     
      const fetchData = async () => {
      
        let header={
          headers:{
          "X-Auth-Token":"12345"
        }};
        dispatch(getPrivacyData(header));
        
      };

      useEffect(() => {
        setPrivacy(state.privacyData);
        setLoading(state.isLoading)
        }, [state])
  return (
    <>
    
    <>
    <Helmet>
          <title>{`CNC Machine :: ${privacy?.page_title}`}</title>
          <meta name="description" content={privacy?.meta_description} />
          <meta name="keywords" content={privacy?.meta_keywords} />
          <meta name="title" content={privacy?.meta_title} />
          <meta property="og:title" content={`CNC Machine :: ${privacy?.page_title}`}/>

        </Helmet>
    
    <section className="aboutcontainer">
    {loading===true?<div className="loader-container">
        <div className="spinner"></div>
      </div>:
  <div className="container">
    <div className="row">
      <div className="col-12">
        <h2>Privacy <span>Policy</span></h2>
      <Markup content={privacy?.page_content} />
        
      </div>
    </div>
  </div>}
</section>
    </>

    </>
  )
}



export default Privacy